import React, { Fragment } from 'react';
import AfterPay from './AfterPay.jsx';
import ProductGallery from './ProductGallery.jsx';
import ProductPromos from './ProductPromos.jsx';
import ProductForm from './ProductForm.jsx';
import ProductDescription from './ProductDescription.jsx';
import SizeGuide from './SizeGuide.jsx';
import ProductContext from './ProductContext.jsx';
import SVG from './SVG.jsx';
import ImageZoom from '../components/ImageZoom';
import trackEvent from '../utils/trackEvent';
import Drawer from './Drawer.jsx';
import EstimatedDelivery from './EstimatedDelivery.jsx';
import ReformatMoney from './ReformatMoney.jsx';
import classNames from 'classnames'; 

export default class Product extends React.Component {
  constructor(props) { 
    super();
   
    const options = {
      'option1': null,
      'option2': null,
      'option3': null
    };

    if (props.defaultVariant) {
      options.option1 = props.defaultVariant.option1
      options.option2 = props.defaultVariant.option2
      options.option3 = props.defaultVariant.option3
    } else if (props.product.en.options.includes('Width')) {
      const widthOptionIndex = props.product.en.options.indexOf('Width');
      const widthOption = props.product.en.options_with_values[widthOptionIndex];
      const propIndex = widthOptionIndex + 1;

      if (props.url.searchParams.has('collection') && props.url.searchParams.get('collection').includes('wide-width')) {
        const wideWidth = widthOption.values.find(v => v.startsWith('Wide'));
        options[`option${propIndex}`] = wideWidth;
      } else if (widthOption.values.includes('Standard')) {
        options[`option${propIndex}`] = 'Standard';
      }
    }

    this.state = {
      imageOverlay: null,
      currentVariant: props.defaultVariant,
      ...options,
      sizeGuideOpen: false,
      fitGuideOpen: false,
      intlSizeGuideOpen: false,
      productVideoModalOpen: false,
      priceDetailsOpen: false,
      media: props.product.media,
      mediaUpdated: 0,
      alternatePriceLayout: !!(window.customExperiences && window.customExperiences["useAlternativePrice"])
    };

    this.productPrice = this.productPrice.bind(this);
    this.breadcrumbs = this.breadcrumbs.bind(this);
    this.alternativeBreadcrumbs = this.alternativeBreadcrumbs.bind(this);
    this.sizeGuides = this.sizeGuides.bind(this);
    // this.productMediaTrigger = this.productMediaTrigger.bind(this);
    this.productVideoModal = this.productVideoModal.bind(this);
    this._colorChange = this._colorChange.bind(this);
    this._optionChange = this._optionChange.bind(this);
    this._variantChange = this._variantChange.bind(this);
    this._openSizeGuide = this._openSizeGuide.bind(this);
    this._openFitGuide = this._openFitGuide.bind(this);
    this._swapSizeGuide = this._swapSizeGuide.bind(this);
    this._openImageZoom = this._openImageZoom.bind(this);
    this._openProductVideoModal = this._openProductVideoModal.bind(this);
    this._openPriceDetails = this._openPriceDetails.bind(this);
  }


  productPrice() {
    
    const price = this.state.currentVariant ? this.state.currentVariant.price : this.props.product.price_min;
    const compare_price = this.state.currentVariant ? this.state.currentVariant.compare_at_price : this.props.product.compare_at_price_min;

    const cName = classNames({
      'price': true,
      'sale': compare_price > price,
      'price-layout-test': this.state.alternatePriceLayout
    }); 
    
    if (!this.state.currentVariant && this.props.product.price_varies) {
      if (this.props.context.productSettings.showPriceMax) {
       
        return   <p className={cName}>
            <span className="money"><ReformatMoney amount={this.props.product.price_max} format={Theme.moneyFormat} /></span>
            {this.props.product.compare_at_price_max > this.props.product.price_max ? <span className="original money"><ReformatMoney amount={this.props.product.compare_at_price_max} format={Theme.moneyFormat} /></span> : null}
           </p>
           
      } else {
        
        return <p className={cName}>
          <span className="money"><ReformatMoney amount={this.props.product.price_min} format={Theme.moneyFormat} /></span>
          {this.props.product.compare_at_price_min > this.props.product.price_min ? <span className="original money"><ReformatMoney amount={this.props.product.compare_at_price_min} format={Theme.moneyFormat} /></span> : null}

        </p>
      }
    }

    return <p className={cName}>
      <span className="money"><ReformatMoney amount={price} format={Theme.moneyFormat} /></span>
      {compare_price > price ? <span className="original money"><ReformatMoney amount={compare_price} format={Theme.moneyFormat} /></span> : null}
      {this.state.alternatePriceLayout && price > 7999 && !this.props.product.tags.includes('FinalSale') ? (
        <Fragment>
          <Drawer open={this.state.priceDetailsOpen} _close={() => this.setState({ priceDetailsOpen: false })} mountOnEnter={true} unmountOnExit={true} heading="Free Shipping & Returns">
            <p>We are proud to offer free shipping within the contiguous U.S. for all orders of $50 or more. Because it's important to us that you love your Thursdays, we also offer free returns/exchanges for items valued at $80 or more — including footwear, apparel, bags, and belts — shipped within the contiguous U.S. See <a href="/pages/return-policy">here</a> for more details.</p>
          </Drawer>
          <span className="price-details"> + FREE Shipping & Returns <button className="price-details-button" onClick={this._openPriceDetails}>Details</button></span>
        </Fragment>
      ) : null}
    </p>
  }

  breadcrumbs() {
    if (this.props.breadcrumbs.length) {
      return <ul className="breadcrumb-navigation">
        {this.props.breadcrumbs.map((breadcrumb, i) => {
          return <li key={i}>
            <a href={`${Shopify.locale == 'en' ? '' : '/' + Shopify.locale}/collections/${breadcrumb.handle}`}>{breadcrumb.label}</a>
            <span className="sep">
              <SVG icon="arrow-thin-right" />
            </span>
          </li>
        })}
        <li>{this.props.product.title.split('|')[0]}</li>
      </ul>
    }
    return null
  }

  alternativeBreadcrumbs() {
    if (this.props.breadcrumbs_alt && this.props.breadcrumbs_alt.length) {
      return <ul className="breadcrumb-navigation alternative">
        {this.props.breadcrumbs_alt.map((breadcrumb, i) => {
          const href = breadcrumb.handle.includes('thursday-seconds') 
            ? `${Shopify.locale == 'en' ? '' : '/' + Shopify.locale}/collections/${breadcrumb.handle}?view=clbqawtrvwtvirct3`
            : `${Shopify.locale == 'en' ? '' : '/' + Shopify.locale}/collections/${breadcrumb.handle}`;
          return <li key={i}>
            <a href={href}>{breadcrumb.label}</a>
            <span className="sep">
              <SVG icon="arrow-thin-right" />
            </span>
          </li>
        })}
        <li>{this.props.product.title.split('|')[0]}</li>
      </ul>
    }
    return null
  }

  productVideoModal() {
    const productVideo = this.state.media && this.state.media.filter(media => media.media_type === 'video')[0]
    if (productVideo) {
      return <Drawer open={this.state.productVideoModalOpen} className={"modal"} _close={() => { this.setState({ productVideoModalOpen: false }) }} mountOnEnter={true} unmountOnExit={true}>
        <div className="product-video-container" style={{ paddingBottom: productVideo.aspect_ratio * 100 + '%' }}>
          <video loop playsInline controls autoPlay>
            {productVideo.sources.slice(0).reverse().map((source, i) =>
              <source type={source.mime_type} height={source.height} width={source.width} src={source.url} key={i} />
            )}
          </video>
        </div>
      </Drawer>
    }
    return null
  }

  sizeGuides() {
    if (this.props.sizeGuides) {
      return <React.Fragment>
        {this.props.sizeGuides.fit_guide_html ? <Drawer open={this.state.fitGuideOpen} _close={() => this.setState({ fitGuideOpen: false })} mountOnEnter={false} unmountOnExit={true}>
          <SizeGuide><div dangerouslySetInnerHTML={{ "__html": this.props.sizeGuides.fit_guide_html }}></div></SizeGuide> </Drawer> : null}
        {this.props.sizeGuides.size_guide_html ? <Drawer open={this.state.sizeGuideOpen} _close={() => this.setState({ sizeGuideOpen: false })} mountOnEnter={false} unmountOnExit={true}>
          <SizeGuide><div dangerouslySetInnerHTML={{ "__html": this.props.sizeGuides.size_guide_html }}></div></SizeGuide> </Drawer> : null}
        {this.props.sizeGuides.intl_size_guide_html ? <Drawer open={this.state.intlSizeGuideOpen} _close={() => this.setState({ intlSizeGuideOpen: false })} mountOnEnter={false} unmountOnExit={true}>
          <SizeGuide><div dangerouslySetInnerHTML={{ "__html": this.props.sizeGuides.intl_size_guide_html }}></div></SizeGuide> </Drawer> : null}
      </React.Fragment>
    }
    return null
  }

  /* productMediaTrigger() {
    if (this.props.productVideo) {
      return <button className="product-media-trigger" onClick={this._openProductVideoModal}><SVG icon="video" />{this.props.productVideo.alt}</button>
    }
    return (null);
  } */

  _colorChange(color) {
    if (color.handle === this.props.product.handle) {
      this.setState({ imageOverlay: null })
    } else {
      this.setState({ imageOverlay: color })
      // window.dataLayer.push({ 'event': 'Hover Product Thumbnails', 'product-color': color.title });
    }
  }

  _optionChange(name, value) {
    this.setState({ [name]: value }, this._variantChange);
  }

  _variantChange() {
    const currentVariant = this.props.product.variants.find(v => v.option1 === this.state.option1 && v.option2 === this.state.option2 && v.option3 === this.state.option3);
    this.setState({ currentVariant });
    if (!currentVariant) {
      return;
    }
    this.props.url.searchParams.set('variant', currentVariant.id);
    history.replaceState(currentVariant, '', this.props.url.href);

    if (typeof window.twq === 'function') {
      window.twq('event', 'tw-o41kc-odvd7', {
        contents: [
          {
            content_type: this.props.product.type,
            content_id: currentVariant.id,
            content_name: currentVariant.name,
            content_price: currentVariant.price / 100,
            content_group_id: this.props.product.id
          }
        ]
      });
    }
  }

  _openFitGuide(e) {
    e.preventDefault();
    this.setState({ fitGuideOpen: true })
  }

  _openSizeGuide(e) {
    e.preventDefault();
    this.setState({ sizeGuideOpen: true })
  }

  _swapSizeGuide(e) {
    e.preventDefault();
    this.setState({ intlSizeGuideOpen: this.state.sizeGuideOpen, sizeGuideOpen: this.state.intlSizeGuideOpen })
  }

  _openProductVideoModal(e) {
    e.preventDefault();
    const productVideo = this.state.media && this.state.media.filter(media => media.media_type === 'video')[0];
    if (productVideo) {
      trackEvent('WatchedExplainerVideo', { productTitle: this.props.product.title, handle: this.props.product.handle, buttonText: productVideo.alt, mediaId: productVideo.id });
      this.setState({ productVideoModalOpen: true })
    }
  }

  _openPriceDetails(e) {
    e.preventDefault();
    this.setState({ priceDetailsOpen: true })
  }

  _openImageZoom(id, el) {
    if (!this.imageZoom) {
      const imageZoomMedia = this.state.media.map(src => {
        if (src.media_type === 'model') {
          return {
            "id": src.id,
            "html": `<model-viewer camera-controls="true" poster="${src.preview_image}" src="${src.sources[0].url}" data-shopify-feature="1.2" data-js-focus-visible ar-status="not-presenting"></model-viewer>`
          }
        }
        if (src.media_type == 'video') {
          let htmlString = "";

          if (src.sources) {
            htmlString += `<video class='pswp-video' onloadeddata='heap.track("WatchedExplainerVideo", ${JSON.stringify({ productTitle: this.props.product.title, handle: this.props.product.handle, buttonText: src.alt, mediaId: src.id })})' loop playsInline muted>`;
            src.sources.sort((a, b) => b.height - a.height).map((src) => {
              htmlString += `<source type=${src.mime_type} height=${src.height} width=${src.width} src=${src.url}></source>`
            });

            htmlString += '</video>'
          } else {
            htmlString += `<video class="pswp-video" loop playsInline muted> <source height=${src.height} width=${src.width} src=${this.props.context.productSettings.cdnUrl}${src.alt}></source></video>`
          }

          return {
            "id": src.id,
            "html": htmlString
          }
        }
        return {
          "id": src.id,
          "w": src.width,
          "h": src.height,
          "src": src.src
        }
      });

      this.imageZoom = new ImageZoom(imageZoomMedia, { productHandle: this.props.product.handle });
    }

    this.imageZoom.open(id, el);
  }

  componentDidMount() {
    window.addEventListener('fitFinder:set', e => {
      const variant = this.props.product.variants.find(v => v.id === e.detail.id);
      if (variant) {
        this.setState({ option1: variant.option1, option2: variant.option2, option3: variant.option3 }, this._variantChange)
      }
    });
    window.addEventListener('MonetateUpdated', e => {
      if (window.customExperiences && window.customExperiences["useAlternativeMedia"]) {
        this.setState({ media: this.props.metafields.personalization.alternative_media, mediaUpdated: this.state.mediaUpdated + 1 })
      }
      if (window.customExperiences && window.customExperiences["useAlternativePrice"]) {
        this.setState({ alternatePriceLayout: true })
      }
    })
  }

  render() {
    return <ProductContext.Provider value={this.props.context}>
      <div className="product-page">
        <section className="product-area">
          <div className="showcase left-main-image">
            <this.breadcrumbs />
            {this.props.breadcrumbs_alt && this.props.breadcrumbs_alt.length > 0 && <this.alternativeBreadcrumbs />}
            <ProductGallery media={this.state.media} mediaUpdated={this.state.mediaUpdated} tags={this.props.product.tags} productName={this.props.product.title} handle={this.props.product.handle} thumbPivot={this.props.metafields.thumbnails.pivot} overlay={this.state.imageOverlay} _openImageZoom={this._openImageZoom} _openProductVideoModal={this._openProductVideoModal} />
          </div>
          <div className={`product-details-wrapper ${this.props.product.type}`}>
            <div className="header">
              <h1 className="product-title">{this.props.product.title.split('|')[0]}</h1>
              {/* <MediaQuery maxWidth={719}>
                <this.productMediaTrigger />
              </MediaQuery> */}
            </div>
            <ProductPromos product={this.props.product} blocks={this.props.blocks} metafields={this.props.metafields} position="below-title" _openSizeGuide={this._openSizeGuide} _openFitGuide={this._openFitGuide} sizeGuides={this.props.sizeGuides} />
            <EstimatedDelivery blocks={this.props.blocks} position="below-title" />
            <div className="price-header ">
              <this.productPrice />
              {this.props.context.i18n.priceMessage && !this.props.product.tags.includes('no-price-message') && <div className="price-message" dangerouslySetInnerHTML={{__html: this.props.context.i18n.priceMessage}}></div>}
              {this.props.context.productSettings.showAfterPay && !this.props.product.tags.includes('no-afterpay') && <AfterPay productTags={this.props.product.tags} productPrice={this.props.product.price_min} alternatePriceLayout={this.state.alternatePriceLayout} />}
            </div>
            <ProductPromos product={this.props.product} blocks={this.props.blocks} metafields={this.props.metafields} position="below-price" _openSizeGuide={this._openSizeGuide} _openFitGuide={this._openFitGuide} sizeGuides={this.props.sizeGuides} />
            <EstimatedDelivery blocks={this.props.blocks} position="below-price" />

            <ProductForm {...this.props} currentVariant={this.state.currentVariant} option1={this.state.option1} option2={this.state.option2} option3={this.state.option3} onOptionChange={this._optionChange} onColorChange={this._colorChange} _openSizeGuide={this._openSizeGuide} _openFitGuide={this._openFitGuide} sizeGuides={this.props.sizeGuides} />
          </div>
        </section>
        <ProductDescription
          description={this.props.product.description}
          blocks={this.props.blocks}
          metafields={this.props.metafields}
          productTitle={this.props.product.title}
        />
        <this.sizeGuides />
      </div>
      <this.productVideoModal />
    </ProductContext.Provider>
  }
}
